import React, { useEffect } from 'react';
import './campos-redes-sociais.component.scss';
import { Button, FormControlLabel, TextField } from '@mui/material';
import { useInput } from '../../hooks/useInput.hook';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete';
import { ItensComIconesModel, RedesSociaisModel } from '../../models/footer.model';
import { SalvarPainelService } from '../../services/salvar-painel.service';
import EscolherIconeComponent from '../escolher-icone/escolher-icone.component';
import { url } from 'inspector';

type CamposMenuProps = {
  setVal: (val: any) => void;
  removeItem: (id?: string) => void;
  itemRedesSociais?: RedesSociaisModel;
  index?: number;
}

function CamposRedesSociaisComponent(props: CamposMenuProps) {

  const { value: iconeInputText, bind: bindIconeInputText, setValue: setIconeInputText } = useInput(props.itemRedesSociais?.icone);
  const { value: urlInputText, bind: bindUrlInputText, setValue: setUrlInputText } = useInput(props.itemRedesSociais?.url);

  SalvarPainelService.getSalvar().subscribe(() => {
    handleChangeItem();
  });

  const handleChangeItem = () => {
    props.setVal({
      icone: iconeInputText,
      url: urlInputText,
      id: props.itemRedesSociais?.id
    });
  };

  return (
    <section className="campos-redes-sociais">
      <div className="campo w50">
        <EscolherIconeComponent icone={iconeInputText} setVal={(val) => setIconeInputText(val)} />
      </div>
      {/* <div className="campo w50">
        <TextField {...bindIconeInputText} label="Ícone" />
        <p><a href="https://mui.com/material-ui/material-icons/" target="_blank" rel="noopener noreferrer">Ver ícones</a></p>
      </div> */}

      <div className="campo w50">
        <TextField {...bindUrlInputText} label="URL" />
      </div>

      <div className="bts">
        <Button className='bt remove' onClick={() => props.removeItem(props.itemRedesSociais?.id)}><DeleteIcon /> Remover item</Button>
      </div>
    </section>
  );
}

export default CamposRedesSociaisComponent;
